import type BuyNowRepository from '@/modules/buy-now/domain/BuyNowRepository';
import type { AuthorizedPerson, Cart } from '@/modules/cart/domain/Cart';

const setOnBehalf = (
  repository: BuyNowRepository,
  cartId: string,
  deliveryGroupId: string,
  authorizedPerson: AuthorizedPerson,
  isRegisteredUser: boolean = false
): Promise<Cart> => {
  return repository.setOnBehalf(
    cartId,
    deliveryGroupId,
    authorizedPerson,
    isRegisteredUser
  );
};

export default setOnBehalf;
